module.exports = __webpack_public_path__ + "static/img/shsqhhzyhzs_2.00939c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customer/shsqhhzyhzs_2.jpg
// module id = qxnQ
// module chunks = 15